import { type VariantProps, cva } from "class-variance-authority";

export const typography = cva("", {
  variants: {
    size: {
      "headline-1": "t:text-desktop-headline-1",
      "title-1": "t:text-desktop-title-1",
      "title-2": "t:text-desktop-title-2",
      "title-3": "t:text-desktop-title-3",
      "title-4": "t:text-desktop-title-4",
      "title-5": "t:text-desktop-title-5",
      "title-6": "t:text-desktop-title-6",
      "body-1": "t:text-desktop-body-1",
      "body-2": "t:text-desktop-body-2",
      "body-3": "t:text-desktop-body-3",
      "body-4": "t:text-desktop-body-4",
      "body-demo": "t:text-desktop-body-demo",
      "label-1": "t:text-label-1",
      "label-2": "t:text-label-2",
      "label-3": "t:text-label-3",
      "label-4": "t:text-label-4",
      "label-5": "t:text-label-5",
    },
    sizeMobile: {
      "headline-1": "text-mobile-headline-1",
      "title-1": "text-mobile-title-1",
      "title-2": "text-mobile-title-2",
      "title-3": "text-mobile-title-3",
      "title-4": "text-mobile-title-4",
      "title-5": "text-mobile-title-5",
      "title-6": "text-mobile-title-6",
      "body-1": "text-mobile-body-1",
      "body-2": "text-mobile-body-2",
      "body-3": "text-mobile-body-3",
      "body-4": "text-mobile-body-4",
      "label-1": "text-label-1",
      "label-2": "text-label-2",
      "label-3": "text-label-3",
      "label-4": "text-label-4",
      "label-5": "text-label-5",
    },
    variant: {
      default: "",
      "prominent-1": "",
      "default-italic": "italic",
      "prominent-1-italic": "italic",
      "prominent-2": "",
      "prominent-2-italic": "italic",
    },
  },
  compoundVariants: [
    {
      size: ["headline-1", "title-1", "title-2", "title-3", "title-4", "title-5", "title-6", "label-4"],
      className: "font-sora",
    },
    {
      size: ["body-1", "body-2", "body-3", "body-4", "label-1", "label-2"],
      className: "font-inter",
    },
    {
      size: ["label-3"],
      className: "font-roboto",
    },
    {
      size: [
        "headline-1",
        "title-1",
        "title-2",
        "title-3",
        "title-4",
        "title-5",
        "title-6",
        "label-1",
        "label-3",
        "label-4",
        "label-5",
      ],
      variant: ["prominent-1", "prominent-1-italic"],
      className: "font-semibold",
    },
    {
      size: ["body-1", "body-2", "body-3", "body-4"],
      variant: ["prominent-1", "prominent-1-italic"],
      className: "font-medium",
    },
    {
      size: ["body-1", "body-2", "body-3", "body-4"],
      variant: ["prominent-2", "prominent-2-italic"],
      className: "font-semibold",
    },
    {
      size: ["label-1", "label-2"],
      variant: ["default", "default-italic"],
      className: "font-medium",
    },
    {
      size: ["body-demo"],
      className: "font-boyrun",
    },
  ],
});

export type TypographyVariantProps = VariantProps<typeof typography>;
